import React from "react";
import "./Tile.css";

const TileBookmark = ({
  id,
  title,
  description,
  thumbnail,
  url,
  isResearchPage,
  isSidebarOpen,
}) => {

  const renderDescription = () => {
    if (typeof description === "string") {
      return <p className="tile-description">{description}</p>;
    } else if (description && description.content) {
      return (
        <p className="tile-description">
          {description.content[0]?.content[0]?.value ||
            "No description available"}
        </p>
      );
    }
    return <p className="tile-description">No description available</p>;
  };

  return (
    <div
      className={`tile ${isResearchPage ? "research-page-tile" : ""} ${
        isSidebarOpen ? "sidebar-open" : "sidebar-closed"
      }`}
    >
      <div className="tile-content">
        <a href={url} target="_blank" rel="noopener noreferrer">
          <img src={thumbnail} alt={title} className="tile-thumbnail" />
        </a>
        <h3 className="tile-title">{title}</h3>
        <h4>{renderDescription()}</h4>
      </div>
    </div>
  );
};

export default TileBookmark;
